
























































































































































































































































































































































































































import { Vue, Component, Watch, InjectReactive } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { isArray, sortBy, cloneDeep } from 'lodash';
import CardDataList from '@/components/card-data-list.vue';
import { ISimpleTableColumn } from '@/interfaces/simple-table-column.interface';
import CrmClientDetailsCard from '@/components/crm/client-details-card.vue';
import ClientModel from '@/models/crm/client.model';
import ClientService from '@/services/crm/client.service';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import { ClientStatusEnum } from '@/enums/crm/client-status.enum';
import RouterService from '@/services/router.service';
import UserContactInfo from '@/models/crm/user-contact-info.model';
import ContentDialog from '@/components/content-dialog.vue';
import CrmEmailView from '@/components/crm/email-view.vue';
import ContactService from '@/services/crm/contact.service';
import CrmContactForm from '@/components/crm/contac-form.vue';
import { IKeyValue } from '@/interfaces/key-value.interface';
import { IDialogConfig } from '@/interfaces/dialog-config.interface';
import ConfirmationDialog from '@/components/confirmation-dialog.vue';
import ProcessFlowModel from '@/models/crm/process-flow.model';
import ProcessService from '@/services/crm/process.service';
import CrmNewKanbanViewer from '@/components/crm/new-kanban-viewer.vue';
import ProcessModel from '@/models/crm/process.model';
import ContactModel from '@/models/crm/contact.model';
import { eventBus } from '@/utils/eventBus';
import CrmActivityView from '@/components/crm/activity-view.vue';
import ActivityService from '@/services/crm/activity.service';
import ActivityEventModel from '@/models/crm/activity-event.model';
import SessionService from '@/services/session.service';
import CrmChatCallerButton from '@/components/crm/chat-caller-button.vue';
import { ClientTypeEnum } from '@/enums/client-type.enum';
import CrmProspectForm from '@/components/crm/prospect-form.vue';
import ProspectService from '@/services/crm/prospect.service';
import SettingsModel from '@/models/crm/settings.model';
import ClientManagementService from '@/services/crm/client-management.service';
import ClientManagementModel from '@/models/crm/client-management.model';
import AttendanceService from '@/services/crm/attendance.service';
import ResponsibleAttendantModel from '@/models/crm/responsible-attendant.model';
import { ClientManagerSituationEnum } from '@/enums/crm/client-manager-situation-enum';
import SettingsService from '@/services/crm/settings.service';
import CardContact from '@/components/card-contact.vue';
import CardProcess from '@/components/card-process.vue';
import OriginModel from '@/models/crm/origin.model';
import ContactTypeModel from '@/models/crm/contact-type.model';
import DataGridFilter from '@/components/data-grid-filter.vue';
import { StringHelper } from '@/utils/helpers/string-helper';
import CrmIntegrationFields from '@/components/crm/integration/crm-integration-fields.vue';
import IntegrationFieldValueModel from '@/models/crm/integration-field-value.model';

interface IEvent {
  id: number;
  description: string;
  date: string;
  contact: string;
  type: string;
}

interface IProcess {
  id?: number;
  idProcesso?: number;
  idFluxo: number;
  tipoFluxo?: number;
  description: string;
  step: string;
  idFila: number;
  date: string;
  contact: string;
  allowDetail: boolean;
  hasFlowStep: boolean;
  hasFlowCurrentStep: boolean;
  etapaFinal?: boolean;
  resultado?: string;
  resultadoPositivo?: boolean;
  motivo?: string;
}

interface IContact {
  id: number;
  email: string;
  phone: string;
  type: string | null;
  contact: string;
  model: ContactModel;
}

type DataGridFilterConfig = {
  typeContact: ContactTypeModel[];
  contactChannel: OriginModel[];
  situation: number;
};

@Component({
  components: {
    CardDataList,
    CrmClientDetailsCard,
    ContentDialog,
    ConfirmationDialog,
    CrmProspectForm,
    CrmEmailView,
    CrmContactForm,
    CrmNewKanbanViewer,
    CrmActivityView,
    CrmChatCallerButton,
    CardContact,
    CardProcess,
    DataGridFilter,
    CrmIntegrationFields,
  },
})
export default class CrmDashboard extends Vue {
  @inject(InjectionIdEnum.SessionService)
  private sessionService!: SessionService;

  @inject(InjectionIdEnum.CrmClientService)
  private clientService!: ClientService;

  @inject(InjectionIdEnum.CrmContactService)
  private contactService!: ContactService;

  @inject(InjectionIdEnum.CrmProcessService)
  private processService!: ProcessService;

  @inject(InjectionIdEnum.CrmActivityService)
  private activityService!: ActivityService;

  @inject(InjectionIdEnum.CrmProspectService)
  private prospectService!: ProspectService;

  @inject(InjectionIdEnum.RouterService)
  private routerService!: RouterService;

  @inject(InjectionIdEnum.CrmClientManagementService)
  private clientManagementService!: ClientManagementService;

  @inject(InjectionIdEnum.AttendanceService)
  private attendanceService!: AttendanceService;

  @inject(InjectionIdEnum.CrmSettingsService)
  private settingsService!: SettingsService;

  @InjectReactive('activeClient') readonly activeClient!: ClientModel;

  @InjectReactive('clientType') readonly clientType!: ClientTypeEnum;

  @InjectReactive('userContactInfo') readonly userContactInfo!: UserContactInfo;

  @InjectReactive('settings') settings!: SettingsModel; // Removido readonly no ATD-16689

  attendantsList: ResponsibleAttendantModel[] = [];

  allClientManagements: ClientManagementModel[] = [];

  client: ClientModel = new ClientModel();

  currentContact!: ContactModel;

  processesList: ProcessModel[] = [];

  contactsList: ContactModel[] = [];

  mainContactInfo: ContactModel | undefined;

  eventsList: ActivityEventModel[] = [];

  idFila = -1;

  loadingSummary = false;

  loadingProcesses = false;

  loadingContacts = false;

  // Guarda a chamada mais recente de loadContacts(): o Painel de Relacionamento reaproveita
  // a mesma instância do componente ao trocar de cliente/prospect (rota dashboard/:clientId),
  // então uma resposta antiga que resolve depois de uma nova navegação não pode sobrescrever
  // a lista de contatos do cliente atual (SUS-13211).
  private contactsRequestSeq = 0;

  loadingEvents = false;

  disableCards = false;

  integrationFields: IntegrationFieldValueModel[] = [];

  loadingIntegrationFields = false;

  clientNotIntegrated = false;

  disableParticularities = false;

  clientDetailsActionsLoading = false;

  disabledPhone = false;

  disabledWhatsApp = false;

  filters: DataGridFilterConfig = {
    typeContact: new Array<ContactTypeModel>(),
    contactChannel: new Array<OriginModel>(),
    situation: 1,
  };

  contactTypeOptions: ContactTypeModel[] = [];

  channelOptions: OriginModel[] = [];

  contactsListFilter!: ContactModel[] | null;

  isVisible = false;

  emailAddressee!: string;

  contactStatusFilterOptions: { id: number; nome: string }[] = [
    {
      id: 1,
      nome: this.activeContactStatusDescription,
    },
    {
      id: 2,
      nome: this.inactiveContactStatusDescription,
    },
    {
      id: -1,
      nome: this.allStatusDescription,
    },
  ];

  eventDataListColumns: ISimpleTableColumn[] = [
    {
      name: `${this.$t('crm.view.dashboard.schedule')}`,
      prop: 'description',
    },
    {
      name: `${this.$t('crm.view.dashboard.dateAndHour')}`,
      prop: 'date',
      width: '150px',
    },
    {
      name: `${this.$t('crm.view.dashboard.attendant')}`,
      prop: 'contact',
    },
    {
      name: `${this.$t('crm.view.dashboard.historyType')}`,
      prop: 'type',
    },
    {
      name: `${this.$t('crm.view.dashboard.status')}`,
      prop: 'status',
    },
  ];

  processDataListColumns: ISimpleTableColumn[] = [
    {
      name: `${this.$t('crm.view.dashboard.name')}`,
      prop: 'description',
    },
    {
      name: `${this.$t('crm.view.dashboard.lastStep')}`,
      prop: 'step',
    },
    {
      name: `${this.$t('crm.view.dashboard.dateAndHour')}`,
      prop: 'date',
      width: '150px',
    },
    {
      name: `${this.$t('crm.view.dashboard.attendant')}`,
      prop: 'contact',
    },
  ];

  colors = new Map([
    ['eventBlue', 'rgb(58, 83, 155)'],
    ['eventYellow', 'rgb(247, 202, 24)'],
    ['eventGreen', 'rgb(30, 130, 76)'],
    ['eventRed', 'rgb(192, 57, 43)'],
    ['eventOrange', 'rgb(249, 105, 14)'],
    ['eventPurple', 'rgb(145, 61, 136)'],
  ]);

  dialogConfig: IKeyValue<IDialogConfig> = {
    confirmation: {
      message: '',
      color: '',
      show: false,
      onChoice: () => {},
    },
    sendEmail: {
      show: false,
    },
    contactForm: {
      show: false,
      id: null,
      cnpj: null,
      prefill: null,
      hasExistingContacts: false,
    },
    processKanban: {
      show: false,
      idFluxo: null,
      nomeFluxo: null,
      process: null as IProcess | null,
      fromPainelRelacionamento: false,
    },
    activityView: {
      show: false,
      id: null,
    },
    prospect: {
      show: false,
      id: null,
      hasExistingContacts: false,
    },
    particularities: {
      show: false,
      editing: false,
      saving: false,
      description: '',
    },
  };

  processFlowOptions: ProcessFlowModel[] = [];

  expandedProcess = false;

  async created(): Promise<void> {
    // Tratativa feita para o ATD-16689, o Kanban não chama o index.vue
    if (this.settings === null) {
      this.settings = await this.settingsService.getSettings();
    }
  }

  async mounted(): Promise<void> {
    this.contactsListFilter = null;
    this.loadProcessFlows();
    this.loadClientSummary();
    this.loadContacts();
    this.loadProcesses();
    this.loadEvents();
    this.loadAttendants();
    this.loadContactTypes();
    this.loadOrigins();
    this.disableButtonsContact();
    eventBus.$on('edit-prospect-complete', this.onProspectEditComplete);
    localStorage.setItem('activeClient', JSON.stringify(this.activeClient));
    localStorage.setItem('userContactInfo', JSON.stringify(this.userContactInfo));
    localStorage.setItem('clientType', JSON.stringify(this.clientType));
    localStorage.setItem('settings', JSON.stringify(this.settings));
    localStorage.setItem('sessionService', JSON.stringify(this.sessionService));
    localStorage.setItem('socketIOUrl', this.sessionService.socketIOUrl);
    localStorage.setItem('mainContactInfo', JSON.stringify(this.mainContactInfo));
  }

  beforeDestroy(): void {
    eventBus.$off('edit-prospect-complete', this.onProspectEditComplete);
  }

  private onProspectEditComplete(): void {
    this.loadContacts();
  }

  @Watch('$route')
  async watchRoute(): Promise<void> {
    // Tratativa feita para o ATD-16689, o Kanban não chama o index.vue
    if (this.settings === null) {
      this.settings = await this.settingsService.getSettings();
    }

    this.loadClientSummary();
    this.loadContacts();
    this.loadProcesses();
    this.loadEvents();
    this.loadAttendants();
    this.loadContactTypes();
    this.loadOrigins();
  }

  onSendEmail(email: string): void {
    this.emailAddressee = email;
    this.dialogConfig.sendEmail.show = true;
  }

  // #endregion Contact

  onAddContact(): void {
    this.dialogConfig.contactForm.id = null;
    this.dialogConfig.contactForm.prefill = null;
    this.dialogConfig.contactForm.show = true;
  }

  async onEditContact(item: IContact): Promise<void> {
    // O contato sintetico (id = -1) nao existe em crmcontatos: editar por id retornaria
    // "Parameter 'ID' invalid". Abre o cadastro ja preenchido com os dados do prospect
    // para que o contato principal passe a existir de fato.
    if (!item.id || item.id <= 0) {
      this.dialogConfig.contactForm.id = null;
      this.dialogConfig.contactForm.prefill = cloneDeep(item) as unknown as ContactModel;
      this.dialogConfig.contactForm.show = true;
      return;
    }

    this.dialogConfig.contactForm.id = item.id;
    this.dialogConfig.contactForm.prefill = null;
    this.dialogConfig.contactForm.show = true;
  }

  async onAfterSaveContact(model: ContactModel, saved: boolean): Promise<void> {
    this.dialogConfig.contactForm.hasExistingContacts = false;
    if (saved) this.loadContacts();
    if (this.settings.flagEnviaContatoErp && model.idProspect == null && model.cnpj !== null) {
      const loader = this.$loading.show();
      try {
        this.$notify.info(`${this.$t('crm.view.dashboard.contact.message.sendToErp')}`);
        const res = await this.contactService.sendToErp(model);
        this.$notify.success(res);
      } catch (err) {
        const message = err && (err as Error).message;
        this.$notify.error(`${message}`);
      } finally {
        loader.hide();
      }
    }
  }

  async onDeleteContact(item: IContact): Promise<void> {
    this.beforeDeleteConfirmation(`${this.$t('global.youAreSureDeleteRecord')}`, async (accept: boolean) => {
      if (accept) {
        const currentList = this.contactsList;

        const loader = this.$loading.show();
        try {
          this.contactsList = this.contactsList.filter((x) => x.id !== item.id);

          await this.contactService.delete(item.id);
        } catch (err) {
          this.contactsList = currentList;

          this.$notify.error(err && (err as Error).message);
        } finally {
          loader.hide();
          this.dialogConfig.contactForm.show = false;
        }
      }
    });
  }

  // #endregion

  // #region Process

  onAddProcess(flow: ProcessFlowModel): void {
    /*
     O trecho abaixo está comentado pois essas alterações são apenas um paliativo temporário
     da questão de não abrir o kanban por dentro do Vue
     */
    // this.dialogConfig.processKanban.idFluxo = flow.id;
    // this.dialogConfig.processKanban.nomeFluxo = flow.nome;
    // this.dialogConfig.processKanban.clientId = this.client.codCliente;
    // this.dialogConfig.processKanban.clientType = this.clientType;
    // this.idFila = -1;
    // this.dialogConfig.processKanban.show = true;
    if (this.processService.openNewProcessInGeoTab(flow.id, flow.nome, this.client.codCliente, this.clientType)) {
      return;
    }

    const kanbanUrl = this.processService.getNewKanbanUrl(
      flow.id,
      this.client.codCliente,
      this.clientType,
      -1,
      0,
      true,
      this.client.representante.codigo,
    );

    window.open(kanbanUrl, '_blank');
  }

  async onEditProcess(item: IProcess): Promise<void> {
    if (item.hasFlowCurrentStep || (item.allowDetail && item.hasFlowStep)) {
      this.dialogConfig.processKanban.idFluxo = item.idFluxo;
      this.dialogConfig.processKanban.nomeFluxo = item.description;

      this.dialogConfig.processKanban.process = item;
      this.idFila = item.idFila;
      this.dialogConfig.processKanban.clientId = this.client.codCliente;
      this.dialogConfig.processKanban.clientType = this.clientType;
      this.dialogConfig.processKanban.show = true;
    } else {
      this.$notify.error(this.$t('crm.view.dashboard.messages.detailNotAuthorized'));
    }
  }

  onOpenProcessModal(item: IProcess): void {
    this.dialogConfig.processKanban.idFluxo = item.idFluxo;
    this.dialogConfig.processKanban.nomeFluxo = item.description;
    this.dialogConfig.processKanban.process = item;
    this.idFila = item.idFila;
    this.dialogConfig.processKanban.clientId = this.client.codCliente;
    this.dialogConfig.processKanban.clientType = this.clientType;
    this.dialogConfig.processKanban.fromPainelRelacionamento = true;
    this.dialogConfig.processKanban.show = true;
  }

  onAfterKanbanClose(): void {
    this.dialogConfig.processKanban.process = null;
    this.dialogConfig.processKanban.fromPainelRelacionamento = false;
    this.loadProcesses();
  }

  get showAddProcess(): boolean {
    return !!this.processFlowOptions.length && !this.sessionService.builtInMode;
  }

  get showEditProcess(): boolean {
    return !this.sessionService.builtInMode;
  }

  get isConvertedProspect(): boolean {
    return this.client.situacao === ClientStatusEnum.Converted;
  }

  get hasIntegrationFields(): boolean {
    return Array.isArray(this.integrationFields)
      && this.integrationFields.some((f) => f.valor && f.valor.trim().length > 0);
  }

  get activeStatusDescription(): string {
    return this.$t('crm.view.dashboard.contact.status.active').toString();
  }

  get activeContactStatusDescription(): string {
    return this.$t('crm.view.dashboard.contact.status.activeContacts').toString();
  }

  get inactiveStatusDescription(): string {
    return this.$t('crm.view.dashboard.contact.status.inactive').toString();
  }

  get inactiveContactStatusDescription(): string {
    return this.$t('crm.view.dashboard.contact.status.inactiveContacts').toString();
  }

  get allStatusDescription(): string {
    return this.$t('crm.view.dashboard.contact.status.both').toString();
  }

  get processKanbanId(): number | undefined {
    const { process } = this.dialogConfig.processKanban;
    if (!process) return undefined;
    const typedProcess = process as IProcess;
    return typedProcess.id || typedProcess.idProcesso;
  }

  // #endregion

  // #region Activity

  onAddEvent(): void {
    this.dialogConfig.activityView.id = null;
    this.dialogConfig.activityView.show = true;
  }

  onEditEvent(item: IEvent): void {
    this.dialogConfig.activityView.id = item.id;
    this.dialogConfig.activityView.show = true;
  }

  onAfterActivityViewClose(): void {
    this.loadEvents();
  }

  // #endregion

  // #region Prospect

  async onEditProspect(model: ClientModel): Promise<void> {
    await this.loadContacts();
    const mainContact = this.contactsList.find((x) => x.contatoPrincipal === 1);
    this.mainContactInfo = mainContact;
    this.dialogConfig.prospect.id = parseInt(model.codCliente, 10);
    this.dialogConfig.prospect.mainContactInfoClone = cloneDeep(this.mainContactInfo);
    this.dialogConfig.prospect.show = true;
  }

  async onTransformProspect(model: ClientModel): Promise<void> {
    if (model?.codCliente) {
      this.clientDetailsActionsLoading = true;

      try {
        const result = await this.prospectService.transformToClient(this.client.codCliente);
        this.client.situacao = ClientStatusEnum.Converted;
        this.activeClient.situacao = ClientStatusEnum.Converted;

        this.$notify.success(result, 8000);
      } catch (err) {
        this.client.situacao = ClientStatusEnum.ConversionFailed;
        this.activeClient.situacao = ClientStatusEnum.ConversionFailed;
        this.$notify.error(err && (err as Error).message, 5000);
      } finally {
        this.clientDetailsActionsLoading = false;
      }
    }
  }

  onDeleteProspect(model: ClientModel): void {
    this.beforeDeleteConfirmation(`${this.$t('global.youAreSureDeleteRecord')}`, async (accept: boolean) => {
      if (accept) {
        this.clientDetailsActionsLoading = true;

        try {
          await this.prospectService.delete(model.codCliente);

          this.$notify.success(this.$t('crm.view.dashboard.messages.prospectSuccessfullyDeleted'));
          this.routerService.navigate({ name: 'CrmHome' });
        } catch (err) {
          if (err && (err as Error).message.toLowerCase().includes('constraint')) {
            this.$notify.error(this.$t('crm.view.dashboard.messages.prospectNotDeletedConstraint'));
            return;
          }
          this.$notify.error(this.$t('crm.view.dashboard.messages.prospectNotDeleted'));
        } finally {
          this.clientDetailsActionsLoading = false;
        }
      }
    });
  }

  onOpenParticularities(): void {
    this.dialogConfig.particularities.show = true;
  }

  onCloseParticularities(): void {
    if (this.dialogConfig.particularities.editing && !this.dialogConfig.particularities.saving) {
      this.dialogConfig.particularities.description = this.activeClient.particularidades || '';
    }
    this.dialogConfig.particularities.editing = false;
    this.dialogConfig.particularities.show = false;
  }

  async onSaveParticularities(): Promise<void> {
    this.dialogConfig.particularities.saving = true;
    const loader = this.$loading.show();
    try {
      await this.clientService.saveParticularities(
        this.activeClient.cnpjCpf === '' ? null : this.activeClient.cnpjCpf,
        this.activeClient.type === ClientTypeEnum.Prospect ? this.activeClient.codCliente : null,
        this.activeClient.type,
        (this.dialogConfig.particularities.description as string),
      );
      this.activeClient.particularidades = (this.dialogConfig.particularities.description as string);
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.onCloseParticularities();
      this.dialogConfig.particularities.saving = false;
      loader.hide();
      this.$notify.success(this.$t('crm.view.dashboard.dialog.particularities.saved',
        { clientType: this.activeClient.tipo?.toLowerCase() }));
    }
  }

  async onSaveParticularitiesFromCard(event: { client: ClientModel; description: string }): Promise<void> {
    const loader = this.$loading.show();
    try {
      await this.clientService.saveParticularities(
        event.client.cnpjCpf === '' ? null : event.client.cnpjCpf,
        event.client.type === ClientTypeEnum.Prospect ? event.client.codCliente : null,
        event.client.type,
        event.description,
      );

      this.activeClient.particularidades = event.description;
      this.client.particularidades = event.description;

      if (this.$refs.clientDetailsCard) {
        const cardRef = (this.$refs.clientDetailsCard as Vue & {
          closeParticularitiesToSave: () => void;
          updateParticularitiesToLocal: (value: string) => void;
        });
        cardRef.closeParticularitiesToSave();
      }

      this.$notify.success(this.$t('crm.view.dashboard.dialog.particularities.saved',
        { clientType: this.activeClient.tipo?.toLowerCase() }));
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      loader.hide();
    }
  }

  onUpdateParticularitiesToLocal(event: { client: ClientModel; description: string }): void {
    this.client.particularidades = event.description;
    this.activeClient.particularidades = event.description;
  }

  onAfterSaveProspect(): void {
    this.dialogConfig.prospect.hasExistingContacts = false;
    this.dialogConfig.prospect.id = null;
    this.dialogConfig.prospect.show = false;
    this.dialogConfig.prospect.mainContactInfoClone = null;
    this.loadClientSummary();
    this.loadContacts();
  }

  // #endregion

  beforeDeleteConfirmation(message: string, onChoice: CallableFunction): void {
    this.dialogConfig.confirmation.message = message;
    this.dialogConfig.confirmation.color = 'red';
    this.dialogConfig.confirmation.onChoice = onChoice;
    this.dialogConfig.confirmation.show = true;
  }

  toggleExpand(): void {
    this.expandedProcess = !this.expandedProcess;
  }

  get eventDataListItems(): IEvent[] {
    return this.eventsList.map((item) => {
      let styleNameAux = item.styleName;
      if (item.styleName === 'eventCyan') {
        styleNameAux = 'eventYellow';
      }

      return {
        id: item.id,
        description: item.titulo,
        date: `${this.$d(item.dataHoraInicio, item.timed ? 'dateTime' : 'short')}`,
        contact: item.atendente?.nome || '',
        type: item.tipoHistorico?.nome,
        status: styleNameAux ? this.$t(`crm.view.dashboard.statusByEventColor.${styleNameAux}`) : '',
        color: styleNameAux,
      };
    });
  }

  get processDataListItems(): IProcess[] {
    const list = this.processesList.map((item) => ({
      id: item.idProcesso,
      idFluxo: item.idFluxo,
      tipoFluxo: item.tipoFluxo,
      description: item.fluxo,
      date: `${this.$d(item.data, 'dateTime')}`,
      step: item.etapa,
      idFila: item.idFila,
      fila: item.fila,
      contact: item.atendente,
      allowDetail: item.permiteDetalharQualquerEtapa,
      hasFlowStep: item.temFluxoEtapaUsuario,
      hasFlowCurrentStep: item.temFluxoEtapaUsuarioEtapaAtual,
      etapaFinal: item.etapaFinal,
      resultado: item.resultado,
      resultadoPositivo: item.resultadoPositivo,
      motivo: item.motivo,
    }));

    return this.expandedProcess ? list : list.slice(0, 3);
  }

  get processCardStyle(): string {
    if (this.loadingProcesses || this.processDataListItems.length === 0) {
      return 'min-height: 180px;';
    }

    const cardHeight = 65;
    const titleHeight = 56;
    const internalPadding = 24;
    const buttonHeight = this.processesList.length > 3 ? 48 : 0;

    const totalHeight = titleHeight + internalPadding + (this.processDataListItems.length * cardHeight) + buttonHeight;

    const minHeight = Math.max(totalHeight, 160);
    const maxHeight = 600;
    const finalHeight = Math.min(minHeight, maxHeight);

    return `min-height: ${finalHeight}px;`;
  }

  get contactFormDialogTitle(): string {
    let titleKey!: string;
    if (this.dialogConfig.contactForm.hasExistingContacts) {
      titleKey = 'crm.view.dashboard.dialog.contactForm.existingContactsTitle';
    } else {
      titleKey = this.dialogConfig.contactForm.id
        ? 'crm.view.dashboard.dialog.contactForm.editTitle'
        : 'crm.view.dashboard.dialog.contactForm.newTitle';
    }
    return `${this.$t(titleKey)}`;
  }

  get prospectFormDialogTitle(): string {
    let titleKey!: string;
    if (this.dialogConfig.prospect.hasExistingContacts) {
      titleKey = 'crm.view.dashboard.dialog.contactForm.existingContactsTitle';
    } else titleKey = 'crm.view.dashboard.dialog.prospect.title';
    return `${this.$t(titleKey)}`;
  }

  get processKanbanDialogTitle(): string {
    return `${this.$t('crm.view.dashboard.dialog.processKanban.title',
      { flow: this.dialogConfig.processKanban.nomeFluxo })}`;
  }

  get editaParticularidades(): boolean {
    return this.settings && this.settings.flagPermiteEditarParticularidades
      ? !this.settings.flagPermiteEditarParticularidades : true;
  }

  private static formatProspectPhone(phone: string | null | undefined): string | null {
    if (!phone) return null;
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10) return `(${digits.substring(0, 2)}) ${digits.substring(2, 6)}-${digits.substring(6)}`;
    if (digits.length === 11) return `(${digits.substring(0, 2)}) ${digits.substring(2, 7)}-${digits.substring(7)}`;
    return null;
  }

  private static formatProspectWhatsapp(phone: string | null | undefined): string | null {
    if (!phone) return null;
    let digits = phone.replace(/\D/g, '');
    if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) {
      digits = digits.substring(2);
    }
    if (digits.length === 10) return `+55 (${digits.substring(0, 2)}) ${digits.substring(2, 6)}-${digits.substring(6)}`;
    if (digits.length === 11) return `+55 (${digits.substring(0, 2)}) ${digits.substring(2, 7)}-${digits.substring(7)}`;
    return null;
  }

  private buildProspectSyntheticContact(): ContactModel | null {
    const telefoneFmt = CrmDashboard.formatProspectPhone(this.client.telefone);
    const whatsappFmt = CrmDashboard.formatProspectWhatsapp(this.client.celular);
    if (!telefoneFmt && !whatsappFmt) return null;

    const digitsOnly = (s: string | null | undefined): string => (s || '').replace(/\D/g, '');
    const prospectTelDigits = digitsOnly(telefoneFmt);
    const prospectWaDigits = digitsOnly(whatsappFmt);

    const hasMatch = this.contactsList.some((c) => {
      const cTel = digitsOnly(c.telefone);
      const cWa = digitsOnly(c.whatsapp);
      return (prospectTelDigits && (cTel === prospectTelDigits || cWa === prospectTelDigits))
        || (prospectWaDigits && (cTel === prospectWaDigits || cWa === prospectWaDigits));
    });

    if (hasMatch) return null;

    const sintetico = new ContactModel();
    sintetico.id = -1;
    sintetico.nome = this.client.contato || this.client.nomeFantasia || this.client.nome
                      || this.$t('crm.view.dashboard.synthContact.defaultName').toString();
    sintetico.telefone = telefoneFmt || '';
    sintetico.whatsapp = whatsappFmt || '';
    sintetico.email = this.client.email || '';
    sintetico.flagInativo = 0;
    sintetico.contatoPrincipal = 0;
    sintetico.tiposContato = null;
    sintetico.canaisContato = [];
    // Contato sintetico nao existe no banco (id=-1): guarda o prospect para o Conversar
    // sincronizar a EMPRESA on-demand (nao ha contato real para o fluxo por contactId).
    const prospectId = Number(this.client.codCliente);
    if (!Number.isNaN(prospectId) && prospectId > 0) {
      sintetico.idProspect = prospectId;
    }
    return sintetico;
  }

  private async loadContacts(): Promise<void> {
    this.loadingContacts = true;
    this.contactsRequestSeq += 1;
    const requestSeq = this.contactsRequestSeq;
    try {
      // Tratativa feita para o ATD-16689, o Kanban não chama o index.vue
      if (this.settings === null) {
        this.settings = await this.settingsService.getSettings();
      }

      const contactsList = await this.contactService.getContacts(
        await this.getClientIdFromRoute(),
        this.clientType,
        this.settings?.flagPermiteClientesSituacao99Crm360,
      );

      // Uma navegação mais recente já disparou outra loadContacts() enquanto esta
      // requisição estava em andamento — descarta a resposta desatualizada.
      if (requestSeq !== this.contactsRequestSeq) return;

      this.contactsList = contactsList;

      if (this.clientType === ClientTypeEnum.Prospect && this.client) {
        const sintetico = this.buildProspectSyntheticContact();
        if (sintetico) this.contactsList.push(sintetico);
      }

      this.contactsList = this.contactsList.sort((a, b) => {
        if (a.contatoPrincipal === 1 && b.contatoPrincipal !== 1) return -1;
        if (a.contatoPrincipal !== 1 && b.contatoPrincipal === 1) return 1;
        return 0;
      });

      this.disableCards = false;
      this.mainContactInfo = this.contactsList.find((x) => x.contatoPrincipal === 1);
      localStorage.setItem('contactsList', JSON.stringify(this.contactsList));
    } catch (err) {
      if (requestSeq !== this.contactsRequestSeq) return;

      this.processesList = [];
      this.contactsList = [];
      this.eventsList = [];
      this.disableCards = true;
      this.disableParticularities = true;
      this.clientNotIntegrated = true;
      this.$notify.error(this.$t('crm.navigation.messages.errorIntegrationClientNotFound'));
    } finally {
      if (requestSeq === this.contactsRequestSeq) {
        this.loadingContacts = false;
      }
    }
  }

  private async loadProcessFlows(): Promise<void> {
    this.processFlowOptions = await this.processService.getFlows();
  }

  private async loadProcesses(): Promise<void> {
    this.loadingProcesses = true;
    try {
      const clientId = await this.getClientIdFromRoute();

      this.processesList = await this.processService.getProcesses(
        clientId,
        this.clientType,
        10,
      );
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.loadingProcesses = false;
    }
  }

  private getKanbanUrl(item: IProcess): string {
    return this.processService.getNewKanbanUrl(
      item.idFluxo,
      this.client.codCliente,
      this.client.type,
      item.idFila,
      item.id,
      true,
      undefined,
      true,
    );
  }

  private async loadEvents(): Promise<void> {
    this.loadingEvents = true;
    try {
      this.eventsList = await this.activityService.getSummaryEvents(
        await this.getClientIdFromRoute(),
        this.clientType,
        5,
      );
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.loadingEvents = false;
    }
  }

  private async loadClientSummary(): Promise<void> {
    const clientId = await this.getClientIdFromRoute();
    if (clientId) {
      this.loadingSummary = true;
      const loader = this.$loading.show();
      try {
        const clientIdParamForManagement = (this.activeClient && this.activeClient.cnpjCpf)
          ? this.activeClient.cnpjCpf
          : clientId;

        const [managementsResponse, clientData] = await Promise.all([
          this.clientType === ClientTypeEnum.Prospect
            ? Promise.resolve(null)
            : this.clientManagementService.getClientsManagement(clientIdParamForManagement),
          this.clientService.get(clientId, this.clientType),
        ]);

        this.allClientManagements = managementsResponse || [];

        const sortedManagements = (this.allClientManagements || [])
          .filter((m) => m.terminationDate
            && (m.managerSituation === ClientManagerSituationEnum.Ativo
             || m.managerSituation === ClientManagerSituationEnum.Encerrado))
          .sort((a, b) => new Date(b.terminationDate).getTime() - new Date(a.terminationDate).getTime())
          .slice(0, this.settings?.quantidadeGestoesPainelRelacionamento ?? 4);

        this.allClientManagements = sortedManagements || [];

        if (!clientData.atendenteChave) {
          clientData.atendenteChave = null;
        }
        this.client = clientData;
        this.$store.commit('activeClient', this.client);

        this.loadIntegrationFields();
      } catch (err) {
        this.$notify.error(err && (err as Error).message);
        this.allClientManagements = [];
      } finally {
        this.loadingSummary = false;
        loader.hide();
      }
      this.dialogConfig.particularities.description = this.client.particularidades || '';

      if (this.settings.flagAbreParticularidadesPainelCliente === 1
        && this.dialogConfig.particularities.description !== '') {
        this.dialogConfig.particularities.show = true;
      }
    }
  }

  private async getClientIdFromRoute(): Promise<string> {
    const currentRoute = this.routerService.route();
    const routeClientId = currentRoute.params && currentRoute.params.clientId;

    if (this.clientType === ClientTypeEnum.Prospect) {
      return routeClientId;
    }
    if (this.activeClient && this.activeClient.cnpjCpf) {
      return this.activeClient.cnpjCpf;
    }
    return routeClientId;
  }

  private async loadAttendants() {
    this.attendantsList = await this.attendanceService.getAttendantList();
    this.attendantsList.sort((a, b) => a.usuario.localeCompare(b.usuario));
    this.attendantsList.unshift({ id: null, usuario: '- Sem Responsável -' });
  }

  private async onSetResponsibleAttendant(attendantId: number | null) {
    try {
      const dataToSave = {
        cnpjCpf: this.client.cnpjCpf,
        crmUsuarioId: attendantId ?? 0,
        prospect: this.client.prospectId,
        clientType: this.clientType,
      };

      await this.attendanceService.setResponsibleAttendant(dataToSave);

      this.$notify.success(this.$t('crm.view.dashboard.responsibleAttendant.success'));
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
      this.client.atendenteChave = null;
    }
  }

  async onIntegrateClient(model: ClientModel): Promise<void> {
    const loader = this.$loading.show();
    try {
      await this.clientService.integrateSingleClient(model.cnpjCpf.replace(/\D/g, ''));

      this.$notify.success(this.$t('crm.view.dashboard.messages.integrateClientSuccessfully'));
      setTimeout(() => this.$router.go(0), 2500);
    } catch (err) {
      this.$notify.error(this.$t('crm.view.dashboard.messages.integrateClientError'));
    } finally {
      loader.hide();
    }
  }

  get evoTalksReady(): boolean {
    return !!(this.settings?.flagUtilizaEvoTalks && this.settings?.urlBaseEvoTalks);
  }

  get dualChatButtons(): boolean {
    return this.evoTalksReady && !!this.settings?.isEvoTalksEGeoChatHabilitado;
  }

  private disableButtonsContact() {
    if (!this.settings.flagWhatsApp360Ativo && !this.evoTalksReady) {
      this.disabledWhatsApp = true;
    }

    const { isCloudTalkPartner } = this.settings;
    const { callCenterAgentId } = this.sessionService;
    const agentIdIsEmpty = StringHelper.isBlank(callCenterAgentId);
    if (!this.settings.flagUtilizaTelefonia || (isCloudTalkPartner && agentIdIsEmpty)) {
      this.disabledPhone = true;
    }
  }

  get activeFilters(): number {
    let active = 0;
    const filtersToIgnore: string[] = [];
    const filterKeys = Object.keys(this.filters);

    filterKeys.forEach((key) => {
      const filter = this.filters[key];
      switch (key) {
        default:
          if (!filtersToIgnore.includes(key) && filter && !(isArray(filter) && !filter.length)) {
            active += 1;
          }
      }
    });

    return active;
  }

  private async loadContactTypes(): Promise<void> {
    this.contactTypeOptions = await this.contactService.getContactTypes();
  }

  private async loadOrigins(): Promise<void> {
    this.channelOptions = sortBy(await this.activityService.getOrigins(), 'descricao');
  }

  public openFilters(): void {
    if (this.isVisible === false) {
      this.isVisible = true;
    } else {
      this.isVisible = false;
    }
  }

  public filtroInicial(): ContactModel[] {
    return this.contactsList.filter((contato) => contato.flagAtivo === 1);
  }

  public onFilterChange(): void {
    let filteredList = this.contactsList;

    if (this.filters.situation >= 0) {
      if (this.filters.situation === 2) {
        filteredList = filteredList
          .filter((contato) => contato.flagAtivo === 0);
      } else {
        filteredList = filteredList
          .filter((contato) => contato.flagAtivo === 1);
      }
    }

    if (this.filters.typeContact.length >= 1) {
      filteredList = filteredList.filter((contato) => contato.tiposContato != null
        && contato.tiposContato.map((i) => i.id)
          .some((tipo) => this.filters.typeContact.map((i) => i.id).includes(tipo)));
    }

    if (this.filters.contactChannel.length >= 1) {
      filteredList = filteredList.filter((contato) => contato.canaisContato.map((i) => i.id)
        .some((tipo) => this.filters.contactChannel.map((i) => i.id).includes(tipo)));
    }

    this.contactsListFilter = filteredList;
  }

  async loadIntegrationFields(): Promise<void> {
    try {
      this.loadingIntegrationFields = true;
      if (this.clientType === ClientTypeEnum.Prospect) {
        this.integrationFields = (this.client && this.client.camposIntegracao) || [];
        return;
      }
      const cnpj = this.client && this.client.cnpjCpf;
      if (!cnpj) {
        this.integrationFields = [];
        return;
      }
      this.integrationFields = await this.clientService.getClientFields(cnpj);
    } catch (err) {
      this.integrationFields = [];
    } finally {
      this.loadingIntegrationFields = false;
    }
  }
}
